const Search = () => {
  return (
    <svg width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m17.9 16.486-3.58-3.58a8 8 0 1 0-1.415 1.413l3.58 3.58a1 1 0 1 0 1.416-1.413ZM13.198 11A6 6 0 1 1 2.804 5a6 6 0 0 1 10.393 6Z"
        fill="#fff"
      />
    </svg>
  );
};
export default Search;
